import axios from '@/lib/axios';
import { PurchaseOrderContractTask, SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0824. 発注案件契約タスクアーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const unarchivePurchaseOrderContractTask = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/unarchive`,
    props
  );
};

export const useUnarchivePurchaseOrderContractTask = () => {
  return useMutation({
    mutationFn: unarchivePurchaseOrderContractTask,
  });
};
